import * as React from 'react'
import {useTranslation, useEnvironment} from '@wix/yoshi-flow-editor'
import {Summary} from '../summary'
import {EventInfo} from '../event-info'
import {SlideInModal} from '../../slide-in-modal'
import {TicketsListContainer} from '../tickets-list-container'
import {Ticket} from '../ticket'
import {SummaryContainer} from '../summary-container'
import {AccessibilityModeButton} from '../accessibility-mode-button'
import s from './tickets.scss'
import {EmptyState} from './empty-state'
import {TicketsProps} from '.'

export const Tickets = ({
  showTickets,
  selectedSeats,
  onBackClick,
  onRemoveClick,
  onCheckoutClick,
  onAccessibilityModeClick,
}: TicketsProps) => {
  const {isMobile} = useEnvironment()
  const {t} = useTranslation()
  const desktop = !isMobile

  return (
    <SlideInModal show={showTickets} onBackClick={onBackClick}>
      {isMobile && !selectedSeats.length ? (
        <EmptyState />
      ) : (
        <>
          <EventInfo />
          <div className={s.title}>{t('seatings_yourTickets', {count: selectedSeats.length})}</div>
          {desktop && !selectedSeats.length ? (
            <div className={s.subtitle}>You can select your seats by clicking on the seating plan. </div>
          ) : null}
          <TicketsListContainer>
            {selectedSeats.map((selectedTicket, index) => (
              <Ticket
                key={selectedTicket.id}
                firstTicket={index === 0}
                lastTicket={index === selectedSeats.length - 1}
                {...selectedTicket}
                onRemoveClick={onRemoveClick}
              />
            ))}
          </TicketsListContainer>
        </>
      )}
      {desktop || selectedSeats.length ? (
        <>
          {desktop ? <AccessibilityModeButton onAccessibilityModeClick={onAccessibilityModeClick} /> : null}
          <SummaryContainer>
            <Summary onCheckoutClick={onCheckoutClick} />
          </SummaryContainer>
        </>
      ) : null}
    </SlideInModal>
  )
}
